import { useContext } from 'react';
import { TOGGLE_COLLAPSE } from 'common/actions/row-groups/types';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { UseRevealEllipsisInTooltipHook } from 'components/ValueWithLinkViewer/types';
import { useLayoutContext } from 'context/LayoutContext';
import { useRevealEllipsisInTooltip } from 'services/hooks';
import { GridRowLabelProps } from './GridRowLabel.props';
import { classes, Root } from './GridRowLabel.styles';
import CollapsibleIcon from '../components/CollapsibleIcon';
import RowTitle from '../components/RowTitle';
import GridFormatter from '../GridFormatter';

const GridRowLabel = ({ cell, currencyFormatter, unitsFormatter, formatterCell }: GridRowLabelProps) => {
  const context = FeaturedSpreadsheetContext;
  const { rowGroups, setRowGroups } = useContext(context);
  const { isExportMode } = useLayoutContext();
  const { tooltipRef, width }
    = useRevealEllipsisInTooltip() as unknown as UseRevealEllipsisInTooltipHook<HTMLDivElement>;

  const toggleRows = () => {
    if (setRowGroups) {
      setRowGroups({
        type: TOGGLE_COLLAPSE,
        row: cell.alias,
        collapseGroups: cell.collapseGroups,
      });
    }
  };

  return (
    <Root ref={tooltipRef} className={classes.label}>
      {formatterCell && <GridFormatter currencyFormatter={currencyFormatter} unitsFormatter={unitsFormatter} />}
      <RowTitle
        cellProps={{
          title: cell.value as string,
          link: cell?.link?.url ? { url: cell?.link?.url } : { url: '' },
          displayBold: cell?.displayBold ?? false,
        }}
        width={width}
        classes={{
          titleRow: classes.titleRow,
          isValuedCompanyCell: classes.isValuedCompanyCell,
        }}
      />
      {!isExportMode && !cell.sideComponent && cell.hasSubRows && cell.showSubRows && rowGroups && (
        <CollapsibleIcon rowGroups={rowGroups} alias={cell.alias} toggleRows={toggleRows} />
      )}
      {!isExportMode && cell.sideComponent && (
        <div
          onClick={toggleRows}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              toggleRows();
            }
          }}
          tabIndex={0}
          role="button">
          {cell.sideComponent}
        </div>
      )}
    </Root>
  );
};

export default GridRowLabel;
